import axios from "axios";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import { Box } from "@mui/material";
import AccordionDetails from "@mui/material/AccordionDetails";
import add from "../../../assets/icons/Add.svg";
import vertexlogo from "../../../assets/icons/neologo.png";
import minus from "../../../assets/icons/Minus.svg";
import { useState } from "react";
import { Slide } from "react-awesome-reveal";
import FooterCard from "./FooterCard";
export default function Footer({ isLargeScreen, setIsLargeScreen, data }) {
    const [email, setEmail] = useState();

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className="  z-40 w-full mt-[100px] px-10 ">
            <div
                className="w-[90%]  mx-auto  py-10 md:py-20 z-40 text-white "
                id="contactpage"
            >
                <div className="flex flex-col lg:flex-row">
                    <div className="flex flex-col lg:flex-row w-full">
                        <div className=" mb-10 flex flex-col gap-7  w-full  lg:w-1/2">
                            <img
                                src={vertexlogo}
                                className="w-[200px]"
                                alt=""
                            />
                            {!isLargeScreen && (
                                <p className="text-[14px] leading-[21px] h12">
                                    Our innovative decentralised edge rendering
                                    engine utilises a global network of nodes to
                                    stream rendered content directly to user
                                    devices, minimising latency while maximising
                                    accessibility.
                                </p>
                            )}
                        </div>

 
                    </div>
                    <div className="flex flex-col w-full">
                        {!isLargeScreen ? (
                            data.footerAccordion.map((item, index) => (
                                <div key={index}>
                                    <FooterCard item={item} />
                                </div>
                            ))
                        ) : (
                            <div className="w-full flex gap-14 mt-14 lg:mt-0">
                                {data.footerAccordion.map((item) => (
                                    <div className=" w-full flex flex-col ">
                                        <p className="text-[18px] leading-[32px] tracking-[3px] mb-3  ">
                                            {item.question}
                                        </p>
                                        <div
                                            className={` ${
                                                item.id === 1
                                                    ? "w-[60%] 2xl:w-full"
                                                    : "w-full"
                                            }  flex flex-col 2xl:flex-row flex-wrap gap-0 `}
                                        >
                                            {item.answer.map(
                                                (answerItem, index) => (
                                                    <div
                                                        key={index}
                                                        className={` ${
                                                            index % 2 === 0
                                                                ? "2xl:w-1/2 w-full"
                                                                : "2xl:w-1/2 w-full"
                                                        }`}
                                                    >
                                                        <h5
                                                            className={`text-[14px] leading-[20px] h-12 ${
                                                                index % 2 === 0
                                                                    ? "text-left"
                                                                    : "text-left 2xl:text-left"
                                                            }`}
                                                        >
                                                            {answerItem}
                                                        </h5>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Contact us  */}
                    </div>
                </div>{" "}
            </div>

            {/* Copyright */}
            <div className="text-center pb-14 items-center  md:mt-10 z-40 text-white  flex flex-col lg:flex-row w-[90%] mx-auto justify-between">
                <div className="mt-5 md:mt-0 lg:w-1/3 flex w-full items-center justify-start  ">
                    <h7 className=" text-[10px] xl:text-[12px] leading-[32px]  text-white mr-2">
                        Powered By: Decentralised real-time Edge Rendering
                    </h7>
                </div>

                <div className="mt-5 md:mt-0 lg:w-1/3 w-full  ">
                    {" "}
                    <h7 className="z-40 h16 text-left  w-full flex text-[12px] leading-[32px] ">
                        Copyright © {new Date().getFullYear()} Neowave Studio
                    </h7>
                </div>
                <div className="flex gap-4 md:mt-0 mt-3   lg:w-1/3 w-full">
                    {" "}
                    <h7 className="z-40 h16 text-left text-[12px] leading-[32px]">
                        {" "}
                        Privacy Policy
                    </h7>
                    <h7 className="z-40 h16 text-left text-[12px] leading-[32px]">
                        {" "}
                        Cookies
                    </h7>
                </div>
            </div>
        </div>
    );
}
